import Dialog from "dialog";
import template from "./dialog-config.html";
import css from "./dialog-config.css";
import {Label}  from "gui";
import DialogDevice from "../dialog-device.js";

class ConfigAirFlowDialog extends DialogDevice {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-airflow", ConfigAirFlowDialog);
  }
  connectedCallback() {
    super.connectedCallback();

    this.spinnerMLM.value = application.devices[this.name].targetValue;
  }
  constructor(...args) {    
    super(...args);
    
    this.show();
  }
  async updatedevice(device) {
    await super.updatedevice(device);

    this.textboxMaximalCapacity.value = `${device.maximalCapacity} ${device.capacityUnit}`;
  }
  async spinnerMLM_change() {
    try {
      await server.rcall(`RM_${this.endpoint}_setMLM`, this.spinnerMLM.value);
    } catch(e) {
      alert(e);
    }
  }
  async buttonWink_click() {
    await server.rcall(`RM_${this.endpoint}_wink`);
  }
}

ConfigAirFlowDialog.constructor();

export default ConfigAirFlowDialog;